import { useMutation } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

type CloneIngredientOptions = {
    ingredientId: number;
    suffix?: string;
};
export const useCloneIngredient = () => {
    const query = useMutation({
        mutationFn: async (options: CloneIngredientOptions) => {
            const { ingredientId, suffix = "copy" } = options;

            const response = await loggedInApiCall.post(`/api/ingredients/${ingredientId}/clone`, {
                suffix,
            });
            return response;
        },
    });

    return query;
};
